import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { AlertService } from 'app/core/alerts/alert.service';
import { inputTimeToDecimal } from 'app/shared/time';

@Component({
    selector: 'app-money-log-td',
    templateUrl: './money-log-td.component.html',
    styleUrls: ['./money-log-td.component.scss'],
    standalone: false
})
export class MoneyLogTdComponent {

    @Input() id: number;
    @Input() kr: number;
    @Input() beskrivelse: string;
    @Input() table: string;
    @Input() felt: string;
    @Input() maxlength = 524288;
    @Input() disabled = false;
    @Input() dayTotal: number;
    @Output() saveKr = new EventEmitter<{ kr: number, beskrivelse: string }>();
    @Output() saveBeskrivelse = new EventEmitter<string>();

    @ViewChild('krInput') krInput: ElementRef;

    constructor(
        private alert: AlertService
    ) {}

    keyup() {} // used to trigger change detection on value

    onChangeKr(newValue: string, beskrivelse: string) {
        if (!newValue && !this.kr) { return; }
        // TODO: This seems wrong!!! It's currency not time!!!
        const convertedValue = inputTimeToDecimal(newValue);
        if (isNaN(+convertedValue)) {
            this.alert.createAlert('Der er fejl i den indtastede værdi', 'danger');
            this.krInput.nativeElement.focus();
            this.krInput.nativeElement.select();
            return;
        }
        if (+convertedValue === this.kr) { return; }
        this.saveKr.emit({kr: +convertedValue, beskrivelse});
        if (+convertedValue === 0) {
            this.onChangeBeskrivelse('');
        }
    }

    onChangeBeskrivelse(newValue: string) {
        if (!newValue && !this.beskrivelse) { return; }
        if (newValue === this.beskrivelse) { return; }
        this.saveBeskrivelse.emit(newValue);
    }
}
